import login from '@tencent/vft-common/login';
var loginPopState = {
  title: '选择你要登录的帐号类型',
  state: false
};
export default {
  data: function data() {
    return loginPopState;
  },
  methods: {
    hide: function hide() {
      loginPopState.state = false;
    },
    loginByQQ: function loginByQQ() {
      login.openLogin({
        type: 'qq'
      });
      return false;
    },
    loginByWx: function loginByWx() {
      login.openLogin({
        type: 'wx'
      });
      return false;
    }
  },
  install: function install(Vue) {
    Vue.prototype.openLogin = function () {
      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '选择你要登录的帐号类型';
      loginPopState.state = true;
      loginPopState.title = title;
    };
    Vue.prototype.closeLogin = function () {
      loginPopState.state = false;
    };
  }
};